import { createApp } from "vue";
import App from "./App.vue";
import { registerAppPlugins } from "@/plugins/registerAppPlugins";

async function bootstrap() {
  const app = createApp(App);
  registerAppPlugins(app);
  app.mount("#app");
}

bootstrap().catch((error) => {
  console.error("Application bootstrap failed", error);
});
